export const PIE_COLORS = [
    "#60a5fa", // blue-400
    "#10b981", // emerald-500
    "#f43f5e", // rose-500
    "#a78bfa", // violet-400
    "#22d3ee", // teal-300 (sky-ish)
    "#34d399", // green-400
    "#f472b6", // pink-400
    "#fb7185", // rose-400
    "#fde047", // yellow-400
    "#2dd4bf", // teal-400
    "#818cf8", // indigo-400
    "#f59e0b", // amber-500
  ];

  export const PIE_COLOURS_REVERSED = [
    "#f59e0b", // amber-500
    "#818cf8", // indigo-400
    "#2dd4bf", // teal-400
    "#fde047", // yellow-400
    "#fb7185", // rose-400
    "#f472b6", // pink-400
    "#34d399", // green-400
    "#22d3ee", // teal-300 (sky-ish)
    "#a78bfa", // violet-400
    "#f43f5e", // rose-500
    "#10b981", // emerald-500
    "#60a5fa", // blue-400
  ];  